<script>
	const { startJourney, enableJourney, navigateToStep } = require('utilities/journeyUtilities');
	const {
		fireEvent,
		events: { JOURNEY_ACTION }
	} = require('utilities/analyticsUtilities');

	module.exports = {
		props: {
			journeyKey: {
				required: true,
				type: String
			},
			journey: {
				required: true,
				type: Object
			},
			status: {
				required: false,
				type: String
			},
			data: {
				required: false,
				type: Object
			}
		},
		components: {
			'journey-icon-container': require('components/journey-icon-container.vue').default
		},
		computed: {
			statusText() {
				const statusDict = {
					active: 'In Progress',
					complete: 'Complete'
				};

				return statusDict[this.status] || '';
			}
		},
		methods: {
			startJourney(type) {
				const journeyKey = this.journeyKey;
				fireEvent(JOURNEY_ACTION, {
					name: journeyKey,
					type,
					idx: 0
				});
				startJourney(journeyKey, true);
			},
			continueJourney() {
				const { idx } = this.data;
				const currentStep = this.journey.steps[idx];
				const journeyKey = this.journeyKey;

				enableJourney(journeyKey);
				fireEvent(JOURNEY_ACTION, {
					name: journeyKey,
					type: 'continue',
					idx
				});
				navigateToStep(currentStep);

				// trigger DOMWatcher for elements on the same page
				window.dispatchEvent(new Event('scroll'));
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'mixins/media';

	.journey-overview {
		display: flex;
		flex-wrap: wrap;
		border-bottom: 1px solid $c-grey;
		padding: 1.5rem 1rem;

		@include media(med) {
			flex-wrap: nowrap;
			align-items: center;
		}

		.journey-body {
			flex-grow: 1;
			display: flex;
			align-items: center;
		}

		.journey-icon-container {
			margin-bottom: auto;
		}

		.journey-info {
			flex: 1 0;
		}

		.journey-title {
			display: inline-block;
			margin: 0 1rem 0 0;
		}

		.journey-status {
			display: inline-block;
			font-weight: 700;

			&.active {
				color: $c-grape-main;
			}

			&.complete {
				color: $c-pill-aad;
			}
		}

		.journey-actions {
			flex: 0 1 18rem;
			display: flex;
			justify-content: flex-end;
			margin: 1rem auto;

			@include media(med) {
				flex-shrink: 0;
			}

			@include media(lg, max) {
				flex-grow: 1;
			}

			button {
				flex: 1 1 8rem;

				&:not(:first-child) {
					margin-left: 1rem;
				}

				@include media(med) {
					flex-grow: 0;
				}
			}
		}
	}
</style>
<template>
	<div class="journey-overview">
		<div class="journey-body">
			<journey-icon-container
				:icon="journey.icon.name"
				:color="journey.icon.color"></journey-icon-container>
			<div class="journey-info">
				<div>
					<h2 class="journey-title">{{ journey.title }}</h2>
					<span
						class="journey-status"
						:class="status"
						>{{ statusText }}</span
					>
				</div>
				<div class="journey-description">{{ journey.description }}</div>
			</div>
		</div>
		<div class="journey-actions">
			<template v-if="status === 'active'">
				<button
					class="button -link restart-journey"
					@click="startJourney('restart')">
					Restart
				</button>
				<button
					class="button continue-journey"
					@click="continueJourney">
					Continue
				</button>
			</template>
			<button
				v-if="status === 'complete'"
				class="button -outline replay-journey"
				@click="startJourney('replay')">
				Replay
			</button>
			<button
				v-if="status === 'available'"
				class="button start-journey"
				@click="startJourney('basecamp-start')">
				Get Started
			</button>
		</div>
	</div>
</template>
